import { urlSearchParams } from '../config/loginCompleteUrlSearchParams';
export const getSearchParamsFromHref = () => new URLSearchParams(window.location.search);
export const isValidLaunchUrl = (launchUrl, validLaunchUrls) => validLaunchUrls
    .map(u => new URL(u))
    .some(u => u.protocol === launchUrl.protocol && u.hostname === launchUrl.hostname && u.pathname === launchUrl.pathname);
export const didSignInFail = (urlParams) => urlParams.get(urlSearchParams.errorType) !== null;
export const createRedirectUrl = (launchUrl, urlParams) => {
    urlParams.delete('launchUrl');
    const data = {};
    urlParams.forEach((val, key) => {
        data[key] = val;
    });
    if (Object.keys(data).length === 0) {
        return launchUrl;
    }
    return `${launchUrl}?${new URLSearchParams(data).toString()}`;
};
export const redirectToUrl = (url) => {
    try {
        window.location.href = url;
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.log('Failed to automatically navigate to: ', url, '. Err: ', err);
    }
};
